import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService } from '../app-settings/app-settings.service';

@Injectable({
  providedIn: 'root',
})
export class HardLogoutGuardService {
  constructor(
    private auth: AuthService,
    private appSettingsService: AppSettingsService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.auth.logout();
    this.appSettingsService.goToLogin();

    return false;
  }
}
